/**
 * TipoCarroceria
 * @author gil
 */
export enum TipoCarroceria {
  ABERTO = 'ABERTO',
  BAU = 'BAÚ',
  FRIGORIFICO = 'FRIGORÍFICO',
  REFRIGERADO = 'REFRIGERADO',
  SIDER = 'SIDER',
  OUTROS = 'OUTROS',
  NA = 'NÃO SE APLICA',
}
